const fbq = (...args) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq(...args);
  }
};

export const trackPageView = () => fbq("track", "PageView");

export const trackViewContent = (product) => {
  if (!product) return;
  fbq("track", "ViewContent", {
    content_ids: [product.sku],
    content_name: product.name,
    content_type: "product",
    value: product.discountPrice > 0 ? product.discountPrice : product.salePrice,
    currency: "VND",
  });
};

export const trackAddToCart = (product, quantity) => {
  if (!product) return;
  const price = product.discountPrice > 0 ? product.discountPrice : product.salePrice;
  fbq("track", "AddToCart", {
    content_ids: [product.sku],
    content_name: product.name,
    content_type: "product",
    value: price * quantity,
    currency: "VND",
    num_items: quantity,
  });
};

export const trackInitiateCheckout = (cart, total) => {
  fbq("track", "InitiateCheckout", {
    content_ids: cart.map((i) => i?.product?.sku).filter(Boolean),
    num_items: cart.reduce((a, c) => a + (c.quantity || 0), 0),
    value: total,
    currency: "VND",
  });
};

export const trackPurchase = (cart, total, orderId) => {
  fbq("track", "Purchase", {
    content_ids: cart.map((i) => i?.product?.sku).filter(Boolean),
    num_items: cart.reduce((a, c) => a + (c.quantity || 0), 0),
    value: total,
    currency: "VND",
    order_id: orderId,
  });
};
